import { NewType, to, from } from "../jazzi/newType";
import { Iso } from "../optics/iso";

export type Formatted = NewType<string>;

export const toFormatted = to<Formatted>;

export const fromFormatted = from<Formatted>;

export type Formatter = Iso<string, Formatted>;